import { AbstractPmsApiService } from './abstract.service';
import { GuestDocument } from '../models';

/**
 * @class GuestDocumentPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GuestDocument>}
 */
export class GuestDocumentPmsApiService extends AbstractPmsApiService {

    static get $inject() {

        return super.$inject.concat(['Upload']);
    }

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/guest/:guestId/document(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {GuestDocument}
     * @protected
     */
    newModel(attributes, ...params) {

        return new GuestDocument(attributes);
    }

    constructor(http, config, eventsBroker, Upload) {

        super(http, config, eventsBroker);

        this.Upload = Upload;
    }

    /**
     * @param {Object=} params
     * @param {Guest=} guest
     * @returns {Promise.<PaginationCollection<GuestDocument>>}
     */
    get(params = {}, guest) {

        const url = this.url({
            guestId: guest.id
        });

        if (guest.is_child) {

            Object.assign(params, {guest_type: 'child'});
        }

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    upload(document, guest, params = {}) {

        const url = this.url({
            guestId: guest.id
        });

        const data = {document};

        if (guest.is_child) {

            Object.assign(data, {guest_type: 'child'});
        }

        if (Object.values(params).length > 0) {

            Object.assign(data, params);
        }

        if (document instanceof File) {
            return this.Upload
                .upload({
                    url: url,
                    headers: this.authHeaders,
                    data: data,
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
        }
    }

    /**
     * @param {GuestDocument} document
     * @param params
     * @returns {Promise.<boolean>}
     */
    delete(document, params = {}) {

        if (document.guest_type) {

            Object.assign(params, {guest_type: document.guest_type});
        }

        if (document.property_id) {

            Object.assign(params, {property_id: document.property_id});
        }

        const url = this.url({
            guestId: document.guest_id,
            id: document.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders,
                params: params,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

}



// WEBPACK FOOTER //
// ./src/pms-api/services/guest-documents.service.js